import { type MutationResolvers } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { setAccessoryDrawerState } from '../../../../Stores'

export const showAccessoryDrawerResolver: MutationResolvers<ApolloResolverContext>['showAccessoryDrawer'] = () => {
    console.debug('io-dashboards showAccessoryDrawerResolver deprecated, use setAccessoryDrawerState')
    setAccessoryDrawerState(true)
    return true
}
